import React, { useEffect, useState } from "react";
import { separadoresDeMil } from "../../../../../utils/actions/firebase/firebaseActions";

export const InventoryShowTable = ({ generalInventory }) => {
	const [dataShow, setDataShow] = useState(generalInventory);

	useEffect(() => {
		setDataShow(generalInventory);
	}, [generalInventory]);

	function handleSearch(e) {
		if (e.target.value === "") {
			return setDataShow(generalInventory);
		}
		setDataShow(
			generalInventory.filter(
				(item) =>
					item.refInventory.toLowerCase().includes(e.target.value) ||
					item.description.toLowerCase().includes(e.target.value)
			)
		);
	}

	return (
		<div>
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					name=""
					id=""
					onChange={handleSearch}
					className="search-box"
				/>
			</div>
			<table className="tabla-inventory">
				<thead>
					<tr className="fila-tabla-procesos-">
						<th className="tabla-column-etiqueta">Referencia</th>
						<th className="tabla-column-etiqueta">Descripción</th>
						<th className="tabla-column-etiqueta">Cantidad</th>
						<th className="tabla-column-etiqueta">Costo/unidad</th>
					</tr>
				</thead>
				<tbody>
					{dataShow.map((productList, index) => (
						<tr key={index}>
							<td className="tabla-column-data">{productList.refInventory}</td>
							<td className="tabla-column-data">{productList.description}</td>
							<td className="tabla-column-data">
								{separadoresDeMil(productList.amount)}
							</td>
							<td className="tabla-column-data">
								{separadoresDeMil(productList.cost.toFixed(2))}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
